export default __webpack_public_path__ + "static/media/icon-arrow-down.a6ed7bff.svg";